// extracted by mini-css-extract-plugin
export default {"review":"Review_review__bO+65","gapList":"Review_gapList__9G3RP","btnReview":"Review_btnReview__t00PN"};